import { render } from "./RedirectArtistSongs.vue?vue&type=template&id=34254c7c"
import script from "./RedirectArtistSongs.vue?vue&type=script&lang=js"
export * from "./RedirectArtistSongs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__